export default __webpack_public_path__ + "static/media/2767.b41fa009.png";